import { render } from "./index_use_paye.vue?vue&type=template&id=1c3694bc"
import script from "./index_use_paye.vue?vue&type=script&lang=js"
export * from "./index_use_paye.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__